<template>
  <div id="form--photos" class="hotel-edit-accordion-6 reference-tour">
    <PmwHeading size="paragraph-80" weight="weight-light" class="form--title">
      Fotos e galeria do hotel
    </PmwHeading>

    <div class="form--row form--row__line">
      <PmwImageUpload
        :value="photoMain"
        :maxSize="1000"
        :imageWidth="655"
        :imageHeight="505"
        :infoIcon="true"
        :fixedJpeg="true"
        title="Foto Principal"
        inputTitle="Foto Principal"
        titleDescription="Foto que aparecerá em destaque no motor de reservas."
        minSizeErrorText="A imagem precisa ter no mínimo a dimensão de 655x505 pixels. Tente novamente com uma imagem maior."
        sizeErrorText="A imagem selecionada excede o limite de tamanho. Tente novamente com uma imagem menor que 1MB"
        sizeInfo="Dimensão recomendada 655 x 505 pixels."
        inputDescription="São aceitos arquivos .JPG e .PNG de até 1MB."
        inputButtonText="Upload do seu computador"
        class="pmw-image-upload__photo-main pmw-image-upload__tooltip-1"
        @change="updateImage($event, 'changePhotoMain')"
      >
        <template #tooltip-content>
          Foto que aparecerá em destaque no motor de reservas e demonstração do
          hotel quando a busca é feita por cidade, ou demontração no site
          letsbook multi.
          <img :src="tooltipImages.image1" class="tooltip--image" />
        </template>
      </PmwImageUpload>

      <PmwImageUpload
        :value="gallery"
        :maxSize="1000"
        :imageWidth="720"
        :imageHeight="480"
        :infoIcon="true"
        :multiple="true"
        :maxImages="50"
        :fixedJpeg="true"
        alertMessage="Não redimensionada"
        title="Galeria"
        inputTitle="Galeria"
        titleDescription="Defina até 50 fotos para a galeria do hotel, incluindo os serviços que oferece e experiência da estadia."
        maxImagesErrorText="Insira até 50 fotos para compor esta galeria."
        minSizeErrorText="A imagem precisa ter no mínimo a dimensão de 720x480 pixels. Tente novamente com uma imagem maior."
        sizeErrorText="A imagem selecionada excede o limite de tamanho. Tente novamente com uma imagem menor que 1MB"
        sizeInfo="Dimensão recomendada 720 x 480 pixels."
        inputDescription="São aceitos arquivos .JPG e .PNG de até 1MB."
        inputButtonText="Upload do seu computador"
        class="pmw-image-upload__gallery pmw-image-upload__tooltip-4 reference-tour"
        id="form--gallery"
        ref="gallery"
        @change="updateImage($event, 'changeGallery')"
        @croped="saveImageGallery($event, gallery, 'changeGallery')"
      >
        <template #tooltip-content>
          Defina até 50 fotos para a galeria do hotel, incluindo os serviços que
          oferece e experiências da estadia.
          <img :src="tooltipImages.image4" class="tooltip--image" />
        </template>
      </PmwImageUpload>
    </div>

    <div class="form--row form--row__line">
      <PmwImageUpload
        :value="galleryMeta"
        :maxSize="1000"
        :imageWidth="1024"
        :imageHeight="1024"
        :multiple="true"
        :maxImages="20"
        :fixedJpeg="true"
        accept=".png, .jpg"
        typeErrorText="A imagem precisa ser do formato .JPG ou .PNG"
        alertMessage="Não redimensionada"
        title="Galeria de fotos Meta"
        inputTitle="Galeria de fotos Meta"
        titleDescription="Defina até 20 fotos para a galeria do Meta."
        maxImagesErrorText="Insira até 20 fotos para compor esta galeria."
        minSizeErrorText="A imagem precisa ter no mínimo a dimensão de 1024x1024 pixels. Tente novamente com uma imagem maior."
        sizeErrorText="A imagem selecionada excede o limite de tamanho. Tente novamente com uma imagem menor que 1MB"
        sizeInfo="Dimensão recomendada 1024 x 1024 pixels."
        inputDescription="São aceitos arquivos .JPG e .PNG de até 1MB."
        inputButtonText="Upload do seu computador"
        class="pmw-image-upload__gallery"
        id="form--gallery-meta"
        ref="gallery"
        @change="updateImage($event, 'changeGalleryMeta')"
        @croped="saveImageGallery($event, galleryMeta, 'changeGalleryMeta')"
      >
        <template #tooltip-content>
          Defina até 20 fotos para a galeria de fotos Meta.
          <img :src="tooltipImages.image4" class="tooltip--image" />
        </template>
      </PmwImageUpload>
    </div>

    <PmwHeading
      size="paragraph-80"
      weight="weight-light"
      class="form--title form--title__with-subtitle"
    >
      Logos do hotel
    </PmwHeading>

    <PmwParagraph class="form--info mb-4" size="paragraph-40">
      Item não obrigatório, caso não deseje alterar para esse hotel, será
      considerado o mesmo da rede.
    </PmwParagraph>

    <div class="form--row form--row__line">
      <PmwImageUpload
        :value="photoEcommerce"
        :maxSize="1000"
        :imageWidth="180"
        :imageHeight="80"
        title="Logo para ecommerce"
        inputTitle="Logo para ecommerce"
        sizeInfo="Dimensão recomendada 180 x 80 pixels."
        minSizeErrorText="A imagem precisa ter no mínimo a dimensão de 180x80 pixels. Tente novamente com uma imagem maior."
        sizeErrorText="A imagem selecionada excede o limite de tamanho. Tente novamente com uma imagem menor que 1MB"
        inputDescription="São aceitos arquivos .JPG e .PNG de até 1MB."
        inputButtonText="Upload do seu computador"
        class="pmw-image-upload__tooltip-5"
        @change="updateImage($event, 'changePhotoEcommerce')"
      >
      </PmwImageUpload>

      <PmwImageUpload
        :value="photoMailReservation"
        :maxSize="1000"
        :imageWidth="235"
        :imageHeight="90"
        :infoIcon="true"
        accept=".png, .jpg"
        typeErrorText="A imagem precisa ser do formato .JPG ou .PNG"
        title="Logo para e-mail de confirmação de reserva."
        inputTitle="Logo para e-mail de confirmação de reserva."
        sizeInfo="Dimensão recomendada 235 x 90 pixels."
        inputDescription="São aceitos arquivos .JPG e .PNG de até 1MB."
        minSizeErrorText="A imagem precisa ter no mínimo a dimensão de 235x90 pixels. Tente novamente com uma imagem maior."
        sizeErrorText="A imagem selecionada excede o limite de tamanho. Tente novamente com uma imagem menor que 1MB"
        inputButtonText="Upload do seu computador"
        class="pmw-image-upload__tooltip-6"
        @change="updateImage($event, 'changePhotoMailReservation')"
      >
        <template #tooltip-content>
          Logo usado no topo do e-mail de confirmação de reserva.
          <img :src="tooltipImages.image6" class="tooltip--image" />
        </template>
      </PmwImageUpload>
    </div>

    <PmwHeading
      size="paragraph-80"
      weight="weight-light"
      class="form--title form--title__with-subtitle"
    >
      Imagens para e-mails e confirmação de compra
    </PmwHeading>

    <PmwParagraph class="form--info mb-4" size="paragraph-40">
      Item não obrigatório, caso não deseje alterar para esse hotel, será
      considerado o mesmo da rede.
    </PmwParagraph>

    <div class="form--row form--row__line">
      <PmwImageUpload
        :value="photoShop"
        :maxSize="1000"
        :imageWidth="120"
        :imageHeight="130"
        :infoIcon="true"
        :fixedJpeg="true"
        title="Foto para finalização da compra"
        inputTitle="Foto para finalização da compra"
        minSizeErrorText="A imagem precisa ter no mínimo a dimensão de 120x130 pixels. Tente novamente com uma imagem maior."
        sizeErrorText="A imagem selecionada excede o limite de tamanho. Tente novamente com uma imagem menor que 1MB"
        sizeInfo="Dimensão recomendada 120 x 130 pixels."
        inputDescription="São aceitos arquivos .JPG e .PNG de até 1MB."
        inputButtonText="Upload do seu computador"
        class="pmw-image-upload__tooltip-2"
        @change="updateImage($event, 'changePhotoShop')"
      >
        <template #titleDescription>
          Defina a foto que aparecerá na página do<br />
          check-out, em cima do carrinho.
        </template>
        <template #tooltip-content>
          Foto que aparecerá na página do check-out, em cima do carrinho.
          <img :src="tooltipImages.image2" class="tooltip--image" />
        </template>
      </PmwImageUpload>

      <PmwImageUpload
        :value="photoEmail"
        :maxSize="1000"
        :imageWidth="650"
        :imageHeight="350"
        :infoIcon="true"
        :fixedJpeg="true"
        title="Foto para e-mail de confirmação"
        inputTitle="Foto para e-mail de confirmação"
        minSizeErrorText="A imagem precisa ter no mínimo a dimensão de 650x350 pixels. Tente novamente com uma imagem maior."
        sizeErrorText="A imagem selecionada excede o limite de tamanho. Tente novamente com uma imagem menor que 1MB"
        sizeInfo="Dimensão recomendada 650 x 350 pixels."
        inputDescription="São aceitos arquivos .JPG e .PNG de até 1MB."
        inputButtonText="Upload do seu computador"
        class="pmw-image-upload__tooltip-3"
        @change="updateImage($event, 'changePhotoEmail')"
      >
        <template #titleDescription>
          Defina a foto que aparecerá em destaque no e-mail<br />
          de confirmação de reserva, logo abaixo do logo.
        </template>
        <template #tooltip-content>
          Foto que aparecerá em destaque no e-mail de confirmação de reserva,
          logo abaixo do logo.
          <img :src="tooltipImages.image3" class="tooltip--image" />
        </template>
      </PmwImageUpload>
    </div>
    <!-- TÍTULO -->
    <PmwHeading
      size="paragraph-80"
      weight="weight-light"
      class="form--subtitle"
    >
      Banner do e-mail de confirmação da reserva
      <PmwInfoTooltip width="208px">
        <template #content>
          O banner irá aparecer em todos os e-mails de confirmação de reserva.
          <img :src="tooltipImages.image7" class="tooltip--image" />
        </template>
      </PmwInfoTooltip>
    </PmwHeading>

    <PmwParagraph class="form--info" size="paragraph-40">
      Defina a imagem e a ação do banner que será exibido no e-mail de
      confirmação da reserva. <br />
      Item não obrigatório
    </PmwParagraph>

    <div
      id="form--banner-title"
      class="reference-tour form--row form--row__line mb-0"
    >
      <PmwImageUpload
        :value="banner"
        :maxSize="1000"
        :imageWidth="600"
        :imageHeight="250"
        :fixedJpeg="true"
        sizeInfo="Dimensão recomendada 600 x 250."
        inputDescription="São aceitos arquivos .JPG e .PNG de até 1MB."
        minSizeErrorText="A imagem precisa ter no mínimo a dimensão de 600x250 pixels. Tente novamente com uma imagem maior."
        sizeErrorText="A imagem selecionada excede o limite de tamanho. Tente novamente com uma imagem menor que 1MB"
        inputButtonText="Upload do seu computador"
        class="pmw-image-upload__without-title reference-tour"
        id="form--banner"
        @change="updateImage($event, 'changeBanner')"
      />

      <div class="form--group-radio">
        <!-- STATUS DO BANNER -->
        <PmwParagraph
          size="paragraph-60"
          weight="medium"
          class="form--subtitle mt-0"
          >Status do banner</PmwParagraph
        >

        <div class="form--row-checklist">
          <!-- ATIVO -->
          <PmwInputRadio
            :value="statusBanner"
            :checked="statusBanner"
            :inputValue="true"
            label="Ativo"
            name="status"
            @input="$emit('changeStatusBanner', $event)"
          />

          <!-- INATIVO -->
          <PmwInputRadio
            :value="statusBanner"
            :checked="!statusBanner"
            :inputValue="false"
            label="Inativo"
            name="status"
            @input="$emit('changeStatusBanner', $event)"
          />
        </div>

        <!-- URL DA AÇÃO -->
        <PmwFormInput
          :value="urlBanner"
          label="URL da ação do banner"
          placeholder="Digite um texto de descrição"
          class="form--input form--input__banner-action"
          id="form--link-banner"
          @input="$emit('changeUrlBanner', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import PmwImageUpload from '@solucoes/components-lib-tmp/src/components/patterns/PmwImageUpload'
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'
import PmwInputRadio from '@solucoes/components-lib-tmp/src/components/elements/PmwInputRadio'
import PmwInfoTooltip from '@solucoes/components-lib-tmp/src/components/patterns/PmwInfoTooltip'

/** Imagens de exemplos de tooltip */
import tooltipImage1 from '@/assets/images/tooltips-input-images/image-1.svg'
import tooltipImage2 from '@/assets/images/tooltips-input-images/image-2.svg'
import tooltipImage3 from '@/assets/images/tooltips-input-images/image-3.svg'
import tooltipImage4 from '@/assets/images/tooltips-input-images/image-4.svg'
import tooltipImage5 from '@/assets/images/tooltips-input-images/image-5.svg'
import tooltipImage6 from '@/assets/images/tooltips-input-images/image-6.svg'
import tooltipImage7 from '@/assets/images/tooltips-input-images/image-7.svg'

export default {
  name: 'ImagesAndBanners',

  components: {
    PmwHeading,
    PmwParagraph,
    PmwImageUpload,
    PmwFormInput,
    PmwInputRadio,
    PmwInfoTooltip
  },

  props: {
    photoMain: {
      type: String,
      default: null
    },

    photoShop: {
      type: String,
      default: null
    },

    photoEmail: {
      type: String,
      default: null
    },

    gallery: {
      type: Array,
      default: () => []
    },

    galleryMeta: {
      type: Array,
      default: () => []
    },

    photoEcommerce: {
      type: String,
      default: null
    },

    photoMailReservation: {
      type: String,
      default: null
    },

    banner: {
      type: String,
      default: null
    },

    /** Status do banner */
    statusBanner: {
      type: Boolean,
      default: false
    },

    /** Url do banner */
    urlBanner: {
      type: String,
      default: null
    },

    /** Erros (array de erros que foram identificados pelo back-end) */
    errors: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      /** Imagens das tooltips */
      tooltipImages: {
        image1: tooltipImage1,
        image2: tooltipImage2,
        image3: tooltipImage3,
        image4: tooltipImage4,
        image5: tooltipImage5,
        image6: tooltipImage6,
        image7: tooltipImage7
      }
    }
  },

  methods: {
    /**
     * Salvar imagem
     * @param {Image} image: Arquivo de imagem
     * @param {String} name: Nome da imagem que será alterada
     */
    updateImage(image, name) {
      /** Valida se é uma imagem */
      if (image instanceof File) {
        return this.saveImage(image, name)
      } else {
        return this.$emit(name, image)
      }
    },

    /**
     * Salvar imagem
     * @param {Image} image: Arquivo de imagem
     * @param {String} name: Nome da imagem que será alterada
     */
    saveImage(image, name) {
      const data = new FormData()
      data.append('imagem', image)
      this.$hotel
        .image(data)
        .then((response) => {
          /** Guardar imagem salva */
          this.$emit(name, response.data.url)
          /** Feedback de sucesso */
          this.$bus.$emit('show-alert-chip', {
            message: 'Imagem redimensionada com sucesso!'
          })
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.messages
          })
          /** Limpar o campo de imagem */
          this.$emit(name, null)
        })
    },

    /**
     * Salvar imagem da galeria
     * @param {Object} data: Objeto com a imagem e a posição na galeria
     * @param {Array} gallery: Array da galeria de imagens
     * @param {String} event: Nome do evento a ser disparado
     */
    saveImageGallery(image, gallery, event = 'changeGallery') {
      const data = new FormData()
      data.append('imagem', image.file)
      this.$hotel
        .image(data)
        .then((response) => {
          const images = gallery

          /** Remover imagem anterior */
          images.splice(image.position, 1)

          /** Adicionar a imagem nova na posição */
          images.splice(image.position, 0, response.data.url)

          this.$emit(event, images)

          /** Feedback de sucesso */
          this.$bus.$emit('show-alert-chip', {
            message: 'Imagem redimensionada com sucesso!'
          })
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.messages
          })

          /** Limpar o campo de imagem */
          const images = gallery
          images[image.position] = null
          this.$emit(event, images)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.reference-tour {
  position: relative;
}
.pmw-info-tooltip .pmw-custom-tooltip--arrow {
  display: none;
}

.pmw-info-tooltip,
.pmw-image-upload {
  ::v-deep {
    .pmw-custom-tooltip {
      display: flex;
      gap: 5px;
      color: $pmw-gray-dark;
      font-size: font-size('size-small');
      line-height: 18px;
    }
    .pmw-box-file {
      padding: 30px 17px 23px 17px;
    }
  }

  .pmw-custom-tooltip--arrow {
    display: none;
  }
}
.pmw-image-upload {
  max-width: 477px;
  ::v-deep {
    .pmw-form-field--label {
      font-size: font-size('size-medium');
      font-weight: font-weight('weight-medium');
      line-height: 21px;
      margin-bottom: 16px;
    }
    .pmw-form-field--description {
      font-size: font-size('size-small');
      line-height: 18px;
    }

    .pmw-box-file {
      margin: 20px auto 33px auto;
    }
  }

  &__photo-main {
    max-width: 300px;

    ::v-deep {
      .pmw-box-file {
        padding: 30px 30px 23px 30px;
      }
    }
  }

  &__without-title {
    ::v-deep {
      .pmw-image-upload--file-label {
        display: none;
      }
      .pmw-box-file {
        margin-top: 0px;
      }
    }
  }

  &__gallery {
    max-width: 680px;
  }

  &__label-white-space ::v-deep {
    label {
      white-space: nowrap;
    }
  }
  &__tooltip-1 ::v-deep .pmw-custom-tooltip {
    min-width: 360px;
  }
  &__tooltip-2 ::v-deep .pmw-custom-tooltip {
    min-width: 208px;
  }
  &__tooltip-3 ::v-deep .pmw-custom-tooltip {
    min-width: 233px;
  }
  &__tooltip-4 ::v-deep .pmw-custom-tooltip {
    min-width: 295px;
    font-size: 10.5px;
    line-height: 15px;
  }
  &__tooltip-5 ::v-deep .pmw-custom-tooltip {
    min-width: 238px;
  }
  &__tooltip-6 ::v-deep .pmw-custom-tooltip {
    min-width: 242px;
  }
}

.pmw-form-field {
  ::v-deep {
    .pmw-form-field--label {
      font-weight: font-weight('weight-medium');
    }
    .form-field--label-wrapper {
      line-height: 21px;
      margin-bottom: 3px;
    }
    .pmw-input {
      background: $white;
    }
    .pmw-input--clear {
      z-index: 0;
    }
    .pmw-input__focus {
      border-color: $pmw-blue;
    }

    .pmw-input--field {
      background: $pmw-white;

      &:focus {
        border-color: $pmw-blue;
      }
    }
    .pmw-custom-tooltip {
      line-height: 18px;
    }
  }
}

.form {
  &--input {
    max-width: 248px;

    /** Alterar cores novas do select */
    ::v-deep {
      .pmw-select--button__caret-sort-up,
      .pmw-select--button__show {
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select--button:focus {
        border-color: pmw-colors('blue-100');
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select-options--item__hover:hover,
      .pmw-select-options--item__checked {
        background-color: pmw-colors('blue-100') !important;
      }

      .pmw-label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &__banner-action {
      max-width: 100%;
      min-width: 500px;
    }
  }

  &--info {
    line-height: 18px;
    margin-bottom: 32px;
    color: $pmw-gray-dark;

    &__subtitle {
      margin-bottom: 20px;
    }
  }

  &--row {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 54px;
    margin-bottom: 70px;

    &__line {
      flex-wrap: unset;
      align-items: flex-start;
    }
  }

  &--title {
    color: pmw-colors('blue-100');
    font-weight: font-weight('weight-medium');
    margin-bottom: 32px;
    position: relative;

    &__with-subtitle {
      margin-bottom: 19px;
    }
  }

  &--subtitle {
    font-size: font-size('size-medium');
    font-weight: font-weight('weight-medium');
    line-height: 21px;
    margin-bottom: 4px;
  }

  &--group-radio {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    gap: 23px;

    p {
      width: 100%;
      margin-top: 0px;
      margin-bottom: 0px !important;
    }

    & > div {
      margin-bottom: 10px;
    }
  }

  &--row-checklist {
    display: flex;
    align-items: center;
    gap: 23px;
  }
}

.pmw-input-radio ::v-deep {
  input:checked ~ {
    .pmw-input-radio--fake-radio {
      border-color: $pmw-blue;

      &:before {
        background-color: $pmw-blue;
      }
    }
  }
}
</style>
